import FormControl from '@mui/material/FormControl';
import VerificationInput from 'react-verification-input';
import theme from 'src/styles/theme';
import { keyframes } from '@emotion/react';

type ConfirmationCodeInputProps = {
  onCodeChange: (enteredCode: string) => void;
  verificationCodeLength: number;
};

export function ConfirmationCodeInput({
  onCodeChange,
  verificationCodeLength = 6,
}: ConfirmationCodeInputProps) {
  const cursorBlink = keyframes`
  from, to { border-color: white }
  50% { border-color: transparent }
`;

  if (verificationCodeLength <= 0) return null;

  return (
    <FormControl
      sx={{
        '& .vi__wrapper': {
          'input.vi': { border: 'none' },
          '.vi__container': {
            height: 'auto',
            width: 'auto',
          },
          '.confirmation-code-input-character': {
            ...theme.typography.h2,
            color: 'white',
            position: 'relative',
            background: 'none!important',
            border: 'none!important',
            outline: 'none',
            height: 'auto',
            minWidth: '65px',
            textAlign: 'center',
          },
          '.confirmation-code-input-character:before': {
            content: '""',
            position: 'absolute',
            zIndex: '-1',
            inset: '0',
            padding: '2px',
            borderRadius: '4px',
            background: theme.palette.primary.vertical,
            WebkitMask:
              'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
            maskComposite: 'exclude',
          },
          '.confirmation-code-input-character-selected:after': {
            content: '""',
            position: 'absolute',
            left: '50%',
            top: '15%',
            bottom: '15%',
            borderRight: '0.15px solid white',
            // The number being divided by 2 below should match the borderRight width to keep the 'cursor' centered
            transform: 'translateX(calc(-1 * calc(0.15px / 2)))',
            animation: `${cursorBlink} .75s step-end infinite`,
          },
        },
      }}
    >
      <VerificationInput
        placeholder="&#8205;"
        inputProps={{ autoComplete: 'one-time-code' }}
        classNames={{
          container: 'confirmation-code-input-container',
          character: 'confirmation-code-input-character',
          characterInactive: 'confirmation-code-input-character-inactive',
          characterSelected: 'confirmation-code-input-character-selected',
        }}
        autoFocus={true}
        validChars={'0-9'}
        length={verificationCodeLength}
        onChange={(enteredCode) => {
          !!onCodeChange && onCodeChange(enteredCode.replace(/[^0-9]/g, ''));
        }}
      />
    </FormControl>
  );
}
